import './main.scss';

import { loadComponents } from '@opten/gin-tonic/helpers/components';
import { SidebarComponent } from './components/sidebar';
import { SlideshowComponent } from './components/slideshow';
import { initSort } from './components/jsInterop/sortable-list';
import {
	downloadFileFromStream,
	blurElement,
	scrollToTop,
	loadLandscapeVideo,
	loadPortraitVideo,
	loadElemIfReady,
} from './components/jsInterop/helpers';
import {
	initGoogleAutocomplete,
	loadMap,
	googleMapsLoadedCallback,
} from './components/jsInterop/google-helpers';
import { PartnerSliderComponent } from './components/partner-slider';
import { AccordionComponent } from './components/accordion';
import { ScrollGalleryComponent } from './components/scroll-gallery';
import {
	KeyVisualAdditionComponent,
	KeyVisualComponent,
} from './components/keyvisual';
import { TestimonialsComponent } from './components/testimonials';
import { MobileMenuComponent } from './components/mobilemenu';
import { CardsComponent } from './components/cards';
import { TeamContactComponent } from './components/team-contact';
import { PartnerOverlayComponent } from './components/partner-overlay';
import {
	CookieBanner,
	loadGoogleTagManager,
} from '@opten/gin-tonic/components/cookie-banner';
// import * as AOS from 'aos';
import { ScrollAnimations } from './components/scoll-animations';
import { TilesTouchComponent } from './components/tiles-touch';
import { GallerySliderMobileComponent } from './components/gallery-swiper-mobile';
import { IframeComponent } from './components/iframe';
import { BlogOverviewComponent } from './components/blog-overview';

loadComponents(
	SidebarComponent,
	PartnerSliderComponent,
	AccordionComponent,
	// ScrollGalleryComponent, // Replaced by ScrollAnimations
	KeyVisualComponent,
	TestimonialsComponent,
	MobileMenuComponent,
	CardsComponent,
	KeyVisualAdditionComponent,
	TeamContactComponent,
	PartnerOverlayComponent,
	ScrollAnimations,
	TilesTouchComponent,
	GallerySliderMobileComponent,
	IframeComponent,
	BlogOverviewComponent
);

/*Sortable-List*/
window.initSort = initSort;

/*Helpers*/
window.downloadFileFromStream = downloadFileFromStream;
window.blurElement = blurElement;
window.scrollToTop = scrollToTop;
window.loadPortraitVideo = loadPortraitVideo;
window.loadLandscapeVideo = loadLandscapeVideo;

/*Google Helpers*/
window.initGoogleAutocomplete = initGoogleAutocomplete;
window.loadMap = loadMap;
window.googleMapsLoaded = googleMapsLoadedCallback;

/*Slideshow*/
declare global {
	interface Window {
		loadSlideshow?: (slideshowClassSelector?: string) => void;
	}
}

// Native scroll restoration fires before ScrollSmoother/ScrollTrigger have
// set up their pins and transforms, causing a visible jump on reload. We
// disable it here and restore the scroll position ourselves once layout has
// settled - see ScrollAnimations.restoreScrollPosition() in scoll-animations.ts.
history.scrollRestoration = 'manual';

window.loadSlideshow = function (slideshowClassSelector?: string) {
	if (slideshowClassSelector !== undefined) {
		console.log(slideshowClassSelector);
		loadElemIfReady(
			'.' + slideshowClassSelector,
			(elem) => new SlideshowComponent(elem)
		);
	}
};

// Initialize Cookie Banner once DOM is ready
document.addEventListener('DOMContentLoaded', () => {
	const bannerEl = document.querySelector<HTMLElement>('.js-cookie-banner');
	if (bannerEl) {
		// Show banner with animation
		bannerEl.classList.add('show');
		// Hook behavior (sets cookie, animates out, and loads GTM if configured)
		const banner = new CookieBanner(bannerEl, {
			runAfterLoad: () => {
				// 1) Load GTM script (if code present on banner)
				const code = bannerEl.getAttribute('data-cookie-gtm');
				loadGoogleTagManager(code);
				// 2) Promote the noscript iframe by replacing data-src -> src
				const gtmIframe = document.querySelector<HTMLIFrameElement>(
					'iframe[data-gtm-iframe][data-src]'
				);
				if (gtmIframe && !gtmIframe.src) {
					const url = gtmIframe.getAttribute('data-src');
					if (url) {
						gtmIframe.setAttribute('src', url);
						// show it if needed (kept hidden by default)
						// gtmIframe.style.display = 'none'; // keep hidden like noscript
					}
				}
			},
		});
	}
});

// var aosInitialized = false;
// window.addEventListener('load', () => {
// 	AOS.init({ duration: 750, anchorPlacement: 'top-center' });
// 	aosInitialized = true;
// });

// window.addEventListener('scroll', () => {
// 	if (aosInitialized) {
// 		AOS.refresh();
// 		document.dispatchEvent(new Event('aos:refresh'));
// 	}
// });

// window.addEventListener('resize', () => {
// 	if (aosInitialized) {
// 		AOS.refresh();
// 		document.dispatchEvent(new Event('aos:refresh'));
// 	}
// });
